import { createContext, useContext } from 'react';

type ContextType = 'default' | 'table-cell';

const defaultRenderContext = 'default' as const satisfies ContextType;

export const WidgetRenderContext =
  createContext<ContextType>(defaultRenderContext);

export const useWidgetRenderContext = () => useContext(WidgetRenderContext);
